import { ApolloClient, gql } from '@apollo/client'
import {
  GetViewUuidsForRecordsListNavigationQuery,
  GetViewUuidsForRecordsListNavigationQueryVariables,
  ViewType,
} from 'types/graphql'

const GetViewUuidsForRecordsListNavigation = gql`
  query GetViewUuidsForRecordsListNavigationQuery($input: GetViewsInput!) {
    getViews(input: $input) {
      id
      uuid
    }
  }
`

/** Fallback when session-only viewUuid was lost (e.g. full page reload). */
export const fetchViewUuidForRecordsListNavigation = async ({
  apolloClient,
  organizationId,
  recordTypeId,
  viewId,
}: {
  apolloClient: ApolloClient<object>
  organizationId: number
  recordTypeId: number
  viewId: number
}): Promise<string | null> => {
  const result = await apolloClient.query<
    GetViewUuidsForRecordsListNavigationQuery,
    GetViewUuidsForRecordsListNavigationQueryVariables
  >({
    query: GetViewUuidsForRecordsListNavigation,
    variables: {
      input: {
        organizationId,
        recordTypeId,
        viewType: 'RecordsForStaffInModule' as ViewType,
      },
    },
    fetchPolicy: 'no-cache',
  })

  const views = result.data?.getViews ?? []
  return views.find((view) => view.id === viewId)?.uuid ?? null
}
